import humps from 'lodash-humps-ts';
import { authAxios } from '@components/Auth';
import { API_V1_BASE } from '@config';
import { snakes } from '@utils/lodash';
import { WithParams } from '@utils/typescript';
import { paginate, Pagination, PaginationParams } from '@models/Pagination';
import { Ingestion, IngestionTypes, IngestableTypes } from '@models/Ingestion';

export type GetAllIngestionParams = PaginationParams & WithParams<{
  ingestable_type: string;
  ingestable_id: number;
}>;

export type CreateIngestionParams = WithParams<{
  ingestable_type: IngestableTypes | '';
  ingestable_id: number;
  ingestion_type: IngestionTypes | '';
  data_csv: File | undefined;
}>;

export class IngestionApi {
  static getAll = async (params: GetAllIngestionParams) => {
    return await authAxios
      .get(`${API_V1_BASE}/user/ingestions`, { params: snakes(params) })
      .then((response) => paginate(response) as [Ingestion[], Pagination]);
  };

  static create = async (params: CreateIngestionParams) => {
    return await authAxios
      .postForm(`${API_V1_BASE}/user/ingestions`, snakes(params))
      .then((response) => humps(response.data) as Ingestion);
  };
}
